import styled from "styled-components";

export const StyledHomeTopShowcase = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(360px, 0.9fr);
  gap: 14px;
  margin-bottom: 28px;

  .home-top-banner,
  .home-top-category-card {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    background: var(--crypto-surface-2);
    border: 1px solid rgba(139, 177, 205, 0.16);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.2);
  }

  .home-top-banner {
    display: block;
    min-height: 220px;
    color: inherit;
    background: #0b2029;
  }

  .home-top-banner-media {
    position: absolute;
    inset: 0;
    display: block;
    color: inherit;
  }

  .home-top-banner-image,
  .home-top-category-card img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .home-top-banner-image {
    animation: homeTopBannerFade 0.42s ease both;
  }

  .home-top-banner-skeleton {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.045),
      rgba(255, 255, 255, 0.11),
      rgba(255, 255, 255, 0.045)
    );
    background-size: 220% 100%;
    animation: homeTopSkeleton 1.35s ease-in-out infinite;
  }

  .home-top-banner-dots {
    position: absolute;
    z-index: 3;
    left: 50%;
    bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 6px 8px;
    border-radius: 999px;
    background: rgba(5, 15, 20, 0.58);
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(8px);
    transform: translateX(-50%);
  }

  .home-top-banner-dot {
    width: 7px;
    height: 7px;
    border: 0;
    border-radius: 50%;
    background: rgba(191, 211, 224, 0.5);
    cursor: pointer;
    padding: 0;
    transition: width 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
  }

  .home-top-banner-dot.is-active {
    width: 19px;
    border-radius: 999px;
    background: var(--crypto-green);
    box-shadow: 0 0 12px rgba(89, 244, 119, 0.42);
  }

  .home-top-category-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .home-top-category-card {
    display: block;
    min-height: 220px;
    text-decoration: none;
    color: #ffffff;
    transform: translateY(0);
    transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  }

  .home-top-category-card.is-loading {
    pointer-events: none;
  }

  .home-top-category-card:hover,
  .home-top-category-card:focus-visible {
    transform: translateY(-4px);
    border-color: rgba(89, 244, 119, 0.52);
    box-shadow: 0 20px 34px rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(89, 244, 119, 0.12);
  }

  .home-top-category-card::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(7, 18, 24, 0.04) 35%, rgba(7, 18, 24, 0.84) 100%);
    pointer-events: none;
  }

  .home-top-category-card.is-loading::after {
    display: none;
  }

  .home-top-category-skeleton {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.04),
        rgba(255, 255, 255, 0.1),
        rgba(255, 255, 255, 0.04)
      ),
      linear-gradient(145deg, rgba(89, 244, 119, 0.08), rgba(20, 40, 51, 0.2));
    background-size: 220% 100%, 100% 100%;
    animation: homeTopSkeleton 1.35s ease-in-out infinite;
  }

  .home-top-category-skeleton::after {
    content: "";
    position: absolute;
    left: 15px;
    right: 15px;
    bottom: 18px;
    height: 12px;
    border-radius: 999px;
    background: rgba(191, 211, 224, 0.18);
  }

  .home-top-category-card img {
    transform: scale(1.01);
    object-position: center 48%;
    transition: transform 0.22s ease, filter 0.22s ease;
  }

  .home-top-category-image.is-casino {
    object-position: center 50%;
  }

  .home-top-category-image.is-sports {
    object-position: center 47%;
  }

  .home-top-category-card:hover img,
  .home-top-category-card:focus-visible img {
    transform: scale(1.05);
    filter: brightness(0.86) saturate(1.08);
  }

  .home-top-category-footer {
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 54px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 15px;
    background: rgba(14, 35, 44, 0.94);
    border-top: 1px solid rgba(175, 209, 226, 0.1);
    backdrop-filter: blur(6px);
  }

  .home-top-category-title {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .home-top-category-title strong {
    display: block;
    color: #ffffff;
    font-size: 16px;
    line-height: 1.1;
    font-weight: 800;
  }

  .home-top-category-title small {
    display: block;
    margin-top: 3px;
    color: #9fb2c1;
    font-size: 11px;
    line-height: 1.1;
    font-weight: 600;
    white-space: nowrap;
  }

  .home-top-category-icon {
    position: relative;
    display: grid;
    place-items: center;
    width: 27px;
    height: 27px;
    color: #c8d8e2;
    flex: 0 0 auto;
    border-radius: 8px;
    background: rgba(6, 17, 23, 0.45);
    box-shadow: inset 0 0 0 1px rgba(197, 220, 232, 0.1);
    transition: color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
  }

  .home-top-category-icon svg {
    width: 20px;
    height: 20px;
    display: block;
  }

  .home-top-category-card:hover .home-top-category-icon,
  .home-top-category-card:focus-visible .home-top-category-icon {
    color: var(--crypto-green);
    background: rgba(25, 73, 46, 0.52);
    box-shadow:
      inset 0 0 0 1px rgba(89, 244, 119, 0.28),
      0 0 14px rgba(89, 244, 119, 0.18);
  }

  .home-top-category-count {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #d6e2e8;
    font-size: 13px;
    font-weight: 800;
    white-space: nowrap;
  }

  .live-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--crypto-green);
    box-shadow: 0 0 8px rgba(89, 244, 119, 0.56);
  }

  @keyframes homeTopSkeleton {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -120% 0;
    }
  }

  @keyframes homeTopBannerFade {
    from {
      opacity: 0;
      transform: scale(1.015);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @media (max-width: 1180px) {
    grid-template-columns: 1fr;

    .home-top-banner,
    .home-top-category-card {
      min-height: 190px;
    }
  }

  @media (max-width: 700px) {
    gap: 10px;
    margin-bottom: 22px;

    .home-top-banner {
      min-height: 148px;
      aspect-ratio: 16 / 7;
    }

    .home-top-banner-image {
      object-fit: contain;
      background: #0b2029;
    }

    .home-top-category-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }

    .home-top-category-card {
      display: flex;
      flex-direction: column;
      min-height: 0;
      aspect-ratio: 0.88 / 1;
      border-radius: 8px;
      background: #0b2029;
    }

    .home-top-category-card::after {
      display: none;
    }

    .home-top-category-card img {
      height: calc(100% - 48px);
      flex: 1 1 auto;
      object-fit: cover;
      object-position: center 50%;
      background: #0b2029;
      transform: scale(1.01);
    }

    .home-top-category-image.is-casino {
      object-position: center 50%;
    }

    .home-top-category-image.is-sports {
      object-position: center 46%;
    }

    .home-top-category-card:hover img,
    .home-top-category-card:focus-visible img {
      transform: scale(1.03);
    }

    .home-top-category-card.is-loading {
      display: block;
    }

    .home-top-category-skeleton::after {
      left: 11px;
      right: 11px;
      bottom: 17px;
      height: 10px;
    }

    .home-top-banner-dots {
      bottom: 9px;
      gap: 6px;
      padding: 5px 7px;
    }

    .home-top-category-footer {
      position: relative;
      min-height: 48px;
      padding: 9px 11px;
      gap: 8px;
      background: #1e3a46;
      border-top: 0;
    }

    .home-top-category-title {
      gap: 0;
    }

    .home-top-category-title .home-top-category-icon,
    .home-top-category-title small {
      display: none;
    }

    .home-top-category-title strong {
      font-size: 17px;
      line-height: 1.05;
      letter-spacing: 0;
      white-space: nowrap;
    }

    .home-top-category-count {
      gap: 5px;
      font-size: 14px;
      font-weight: 700;
    }

    .home-top-category-count .live-dot {
      width: 6px;
      height: 6px;
    }
  }
`;
